<!--
트래킹검수 > 검수화면 > 검수대상 리스트 컴포넌트
(일반검수 리스트)
------------------------------------
-->
<template>
    <div>
        <!-- 검수대상 리스트-->
        <div class="uk-text-large">
            <i class="material-icons uk-text-bottom" style="font-size: 32px">
                build
            </i>
            검수대상 ({{ checkProds.length }})
        </div>
        <app-check-one-prod
            v-for="(prod, index) in checkProds"
            :key="prod.id"
            :prod="prod"
            :csrf-token="csrfToken"
            :login-user-id="loginUserId"
            :prod-total-count-in-tracking="checkProds.length"
            :prod-index-in-tracking="index + 1"
            :expensive-limit="expensiveLimit"

            @done:error="emitCheckOne"
            @done:hold="emitCheckOne"
            @done:ready="emitCheckOne"
            @done:pack="house_id => emitPacking(house_id)"
        >
        </app-check-one-prod>

    </div>
</template>

<script>
    import prodListable from "./listable";

    export default {
        mixins: [
            prodListable,
        ],

        components: {
            //'check-one-prod': require('./check-one-prod.vue').default,
        },

        data: function () {
            return {
            };
        },

        computed: {

        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>